import React from "react";
import Model from "domains/ui/components/Markdown/Viewer/CustomRenderers/Model";
import {
  GetModelsByModelIdApiResponse,
  GetRecommendationsModelsApiResponse,
} from "infra/api/generated/api";

import { Center, Flex, Skeleton, Text } from "@chakra-ui/react";

interface RecommendationsSectionProps {
  model: GetModelsByModelIdApiResponse["model"];
  isLoadingModelRecommendations: boolean;
  modelRecommendations?: GetRecommendationsModelsApiResponse;
  isOnLoraCatalog: boolean;
}

export const RecommendationsSection: React.FC<RecommendationsSectionProps> = ({
  model,
  isLoadingModelRecommendations,
  modelRecommendations,
  isOnLoraCatalog,
}) => {
  if (
    model.type === "sd-1_5" ||
    model.type === "sd-xl" ||
    model.type === "flux.1"
  ) {
    return null;
  }
  return (
    <Flex direction="column" h="full" id="model-recommendations">
      {!!modelRecommendations?.models?.length && (
        <Text py={2} color="textSecondary" size="body.bold.lg">
          {!isOnLoraCatalog ? "More Models" : "Recommended"}
        </Text>
      )}
      <Flex gap={[1, 1.5]}>
        {isLoadingModelRecommendations ? (
          <Center w="full">
            {[0, 1, 2, 3, 4].map((i) => (
              <Skeleton key={i} w="200px" h="full" />
            ))}
          </Center>
        ) : (
          modelRecommendations?.models.map((recommendedModel) => (
            <Model
              key={recommendedModel.id}
              data={recommendedModel as GetModelsByModelIdApiResponse["model"]}
              imageWidth="200px"
              withAddToCompositionButton={isOnLoraCatalog}
            />
          ))
        )}
      </Flex>
    </Flex>
  );
};
